// extracted by mini-css-extract-plugin
export default {"popup":"markers_popup__DSuAr","popup__name":"markers_popup__name__9GTB9","popup__name--compact":"markers_popup__name--compact__CuAix"};